import type { App } from 'vue'
import { vCachedResource } from '@/directives/cached-resource'
import { vPageLoading } from '@/directives/page-loading'
import { vRipple } from '@/directives/ripple'
import { vSparkle } from '@/directives/sparkle'

/**
 * 注册全局指令
 */
export const initDirectives = (app: App) => {
  // 注册缓存资源指令
  app.directive('cached-resource', vCachedResource)

  // 注册页面加载指令
  app.directive('page-loading', vPageLoading)

  // 注册点击水波纹指令
  app.directive('ripple', vRipple)

  // 注册周期性星星闪烁指令
  app.directive('sparkle', vSparkle)
}
